import { scoreName } from "../config/config.js";
import { getContract } from "../contracts/getContract.js";
import { ITonContractParams } from "../types/types.js";

export const getMintedToken = async ({ address }: ITonContractParams) => {
  const { getToken } = getContract(address, scoreName);
  return await getToken();
};
